import { useEffect, useState } from "react";
import { Text } from "@zapier/design-system";
import { cursorAtom } from "@zapier/canvas-state";
import { useSetAtom } from "jotai";

import styles from "./EmbedOverlay.module.css";

export function EmbedOverlay() {
  const setCursorMode = useSetAtom(cursorAtom);
  const [showHints, setShowHints] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setShowHints(false);
    }, 7000);

    setCursorMode("pan");
  }, [setCursorMode]);

  return (
    <>
      <div className={styles.topToolbar}>
        {showHints && (
          <div className={styles.tooltip}>
            <div className={styles.cursor} />
            <Text type="MinimalPrint2" color="PrimeWhite">
              Click and drag to pan around
            </Text>
          </div>
        )}
      </div>
    </>
  );
}
